import { warning } from './warning';

export function deprecate(condition: boolean, info: string, ...args: string[]): void {
    const format = 'Usage of %s has been deprecated and will be removed in the next major version.';
    const rest = args.map(() => ' %s').join('');

    return warning(condition, format + rest, info, ...args);
}
